import { useEffect, useRef, useState } from "react"

import { useAppDispatch, useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { caseManagement, wasmModule } from "@/gluelayer"
import BoltonPanel from "@/modules/Clinical/components/BoltonPanel/boltonPanel"
import Movement from "@/modules/Clinical/components/Movement/movement"
import Report from "@/modules/Clinical/components/Report/report"
import Message from "@/modules/Clinical/components/SideBar/message"
import CaseNote from "@/modules/Clinical/components/CaseNote/caseNote"

import { UploadSTLV2 } from "../components/UploadSTLV2"
import { LRPhotos } from "../LocalRecord/LRPhotos"
import { LRStls } from "../LocalRecord/LRStls"
import { setCurLeftPage, setReportData } from "../udTreatSlice"

import { UDDentalChart } from "./UDDentalChart"
import { UDPhotos } from "./UDPhotos"
import { ScreeshotReport } from "@/modules/Clinical/components/ReportPDF/screenshotReport"

export function LeftPages(props: any) {
  const {
    isEdit,
    isSubmitModification,
    setisSubmitModification,
    showPrompt,
    confirmNavigation,
    cancelNavigation,
    updateCaseFun,
    setisSubmitReply,
    isSubmitReply,
    uploadAllData,
  } = props
  // Add message inputValue state to retain message
  const [inputValue, setInputValue] = useState("")
  const [selectedPlan, setselectedPlan] = useState({ name: undefined, id: undefined })
  const { curLeftPage, reportData, stageObjBySlice, openHistorySplitView,currentRefinementName } = useAppSelector(
    (state: RootState) => state.udTreatService,
  )
  const dispatch = useAppDispatch()
  const curPage = useRef("")
  useEffect(() => {}, [curLeftPage])
  const [stageObj, setStageObj] = useState({
    upList: [],
    downList: [],
    up_current: 0,
    down_current: 0,
  })
  const onClosePage = () => {
    dispatch(setCurLeftPage(""))
  }
  // Report show or hidden
  const [reportShow, setReportShow] = useState<boolean>(false)
  const [openMovement, setopenMovement] = useState(false)
  const [refinementKey, setRefinementKey] = useState<string>("")
  const [boltonPanelShow, setBoltonPanelShow] = useState<boolean>(false)
  const reportPdfRef = useRef(null)
  const openOrUploadReportPdf = (status: "open" | "upload") => {
    reportPdfRef?.current.uploadReportPDF(status)
  }
  const [boltonData, setBoltonData] = useState(null)
  const openHistorySplitViewRef = useRef(openHistorySplitView)
  openHistorySplitViewRef.current = openHistorySplitView 
  const getBoltonFunc = () => {
    const bolton = caseManagement.getBoltonReport(openHistorySplitViewRef.current) || null
    setBoltonData({...bolton})
  }
  
  useEffect(() => {
    if (!wasmModule.isFinishedOpencase) return
    setReportShow(curLeftPage == "report")
    setopenMovement(curLeftPage === "tmtable")
    if (curLeftPage === "bolton") {
      getBoltonFunc()
      setBoltonPanelShow(true)
    }
    curPage.current = curLeftPage
    if (curLeftPage !== "report") return
    const { attachment, toothlist, ipr } =
      caseManagement.getAttachmentIPRReport(openHistorySplitViewRef.current)
    const { lowlist, uplist } = toothlist
    const list = lowlist.concat(uplist)
    dispatch(
      setReportData({
        attachment: attachment,
        toothlist: list,
        iprData: ipr,
      }),
    )
  }, [curLeftPage,currentRefinementName])

  useEffect(() => {
    if (!wasmModule.isFinishedOpencase) return
    getBoltonFunc()
  },[openHistorySplitViewRef.current])

  function getPage(pageName: string) {
    // console.log("pagename::", pageName)
    switch (pageName) {
      case "createcase":
        // dispatch(setCaseOpenStatus("emptycase"))
        // return <UploadSTL onClose={onClosePage} />
        break
      case "createcasev2":
        // dispatch(setCaseOpenStatus("emptycase"))
        return <UploadSTLV2 onClose={onClosePage} />
        break
      case "records":
        return <UDPhotos onClose={onClosePage} />
        break
      case "dentalchart":
        return <UDDentalChart onClose={onClosePage} />
        break
      case "uassist":
        return (
          <Message
            isEdit={isEdit}
            isSubmitModification={isSubmitModification}
            setisSubmitModification={setisSubmitModification}
            showPrompt={showPrompt}
            confirmNavigation={confirmNavigation}
            cancelNavigation={cancelNavigation}
            updateCaseFun={updateCaseFun}
            setisSubmitReply={setisSubmitReply}
            isSubmitReply={isSubmitReply}
            onClosePage={onClosePage}
            uploadAllData={uploadAllData}
            inputValue={inputValue}
            setInputValue={setInputValue}
            selectedPlan={selectedPlan}
            setselectedPlan={setselectedPlan}
          />
        )

      case "report":
        return (
          // <UDReport
          //   onClose={onClosePage}
          //   reportShow={reportShow}
          //   toothlist={reportData.toothlist}
          //   attachment={reportData.attachment}
          //   setReportShow={setReportShow}
          //   iprData={reportData.iprData}
          //   openReportFunc={openOrUploadReportPdf}
          // />
          <>
            <Report
              reportShow={reportShow}
              toothlist={reportData.toothlist}
              attachment={reportData.attachment}
              setReportShow={() => {
                setReportShow(false)
                onClosePage()
              }}
              iprData={reportData.iprData}
              openReportFunc={openOrUploadReportPdf}
              preparation={false}
              isHistory={openHistorySplitViewRef.current}
            />
            <ScreeshotReport
              isReady={true}
              attachment={reportData.attachment}
              toothlist={reportData.toothlist}
              iprData={reportData.iprData}
              ref={reportPdfRef}
            />
          </>
        )
        break
      case "tmtable":
        return (
          <Movement
            open={openMovement}
            setOpen={() => {
              setopenMovement(false)
              onClosePage()
            }}
            refinementKey={refinementKey}
            stageObj={stageObjBySlice}
            isHistory={openHistorySplitViewRef.current}
          ></Movement>
        )
        break
      case "bolton":
        return (
          <BoltonPanel
            data={boltonData}
            setBoltonPanelShow={() => {
              setBoltonPanelShow(false)
              onClosePage()
            }}
            boltonPanelShow={boltonPanelShow}
            closeToothSize={() => {
              // TODO
            }}
            curLeftPage={curLeftPage}
          />
        )
        break
      case "lrphotos":
        return <LRPhotos onClose={onClosePage} />
        break
      case "lrstls":
        return <LRStls onClose={onClosePage} />
        break
      case "notes":
        return <CaseNote onClosePage={onClosePage} />
        break
    }
    return <></>
  }

  return curLeftPage && getPage(curLeftPage)
}
